import React, { useState, useEffect, useRef } from 'react';
import RedrawDataToPost from 'components/layout/RedrawDataToPost.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import frankStyles from 'components/frank/_style.module.scss';

// Ranks the combinations of a section's nests (LayoutActions#layout_part_nesting_combinations) on the sheet the
// section's nest of every part is drawn on, and hands them to the section once, which opens a tab for each of their
// nests. The server ranks them on a job and answers 'processing' until it has, so it asks again; a redraw on another
// sheet before then asks afresh, and the older ranking is never handed over.
export const POLL_INTERVAL_MILLISECONDS = 1500;
// The server frees a ranking nobody finished after five minutes (LayoutPartNestingCombinationsAnswer::PROCESSING_TTL).
export const POLL_DEADLINE_MILLISECONDS = 5 * 60 * 1000;

const LayoutNestCombinations = ({ combinationsUrl, member, busy, onRanked }) => {
  const [finding, setFinding] = useState(false);
  const [ranked, setRanked] = useState(null);
  const askNumber = useRef(0);
  const handedOver = useRef(false);

  const ask = (body, number, startedAt) => {
    fetch(combinationsUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then((response) => response.json())
      .then((data) => {
        if (number !== askNumber.current) { return; }

        if (data.status === 'processing') {
          if (Date.now() - startedAt < POLL_DEADLINE_MILLISECONDS) {
            setTimeout(() => ask(body, number, startedAt), POLL_INTERVAL_MILLISECONDS);
          } else {
            setFinding(false);
          }
          return;
        }

        setFinding(false);
        // A viewer whose redraws are denied would only be shown the drawing defaults again, once per nest.
        if (data.status === 'completed' && data.result === 'OK') { setRanked({ combinations: data.combinations, layout: body.layout }); }
      })
      .catch(() => {
        if (number === askNumber.current) { setFinding(false); }
      });
  };

  useEffect(() => {
    const listener = (event) => {
      if (handedOver.current || event.detail !== member.uuid) { return; }

      askNumber.current += 1;
      setRanked(null);
      setFinding(true);
      ask(RedrawDataToPost({ uuid: member.uuid, member: member }), askNumber.current, Date.now());
    };
    document.addEventListener('layout_redraw_finished', listener);
    return () => { document.removeEventListener('layout_redraw_finished', listener); };
  }, []);

  // Never while the section is being redrawn: its tabs would be replaced mid-redraw.
  useEffect(() => {
    if (ranked == null || busy || handedOver.current) { return; }

    handedOver.current = true;
    onRanked(ranked.combinations, ranked.layout);
    setRanked(null);
  }, [ranked, busy]);

  if (!finding && ranked == null) { return null; }

  // Modal like Frank's ListingProgressOverlay: the section's tabs are replaced when the ranking is handed over.
  // No percentage: the ranking is one answer.
  return (
    <div className={styles.progressOverlay}>
      <div className={styles.progressCard}>
        <div className={styles.progressTitle}>{window.wording_dynamic_nesting_finding_options}</div>
        <div className={styles.progressBarContainer}>
          <div className={frankStyles.indeterminateFill} />
        </div>
      </div>
    </div>
  );
};

export default LayoutNestCombinations;
